import { UserLevel } from "@/api/admin/users";
import { toastError } from "@/components/molecules";

const FORBIDDEN_ASSIGNMENT_MESSAGES: Partial<Record<UserLevel, string>> = {
  [UserLevel.BRAND]:
    "The selected brands cannot be assigned together because they belong to different groups.",
  [UserLevel.BRANCH]:
    "The selected branches cannot be assigned together because they belong to different brands or groups.",
};

const handleInviteError = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any,
  level: UserLevel | undefined,
  retry: () => void
) => {
  if (error?.code === "com.restaurant-user.forbidden-assignment" && level) {
    const message = FORBIDDEN_ASSIGNMENT_MESSAGES[level];

    if (message) {
      toastError(message, retry, "Error");
      return;
    }
  }

  toastError(error?.message, retry, "Error");
};

export default handleInviteError;
